module.exports = __webpack_public_path__ + "static/media/product8.64c883e3.jpg";